var m = require('mithril');
var loaders = require('../../layout/components/loaders');
var Model = require('../../libs/Model');
var formGroup = require('../../components/formGroup');
var prop = require('mithril/stream');

var modbusAddress = Object.create(Model);

modbusAddress.name = 'Modbus Address';
modbusAddress['@class'] = 'ModbusAddress';
modbusAddress.url = 'modbusAddress';

modbusAddress.fields = {
  parent: {
    default: null,
    hidden: true
  },
  name: {
    type: 'string',
    default: null,
    validators: {
      presence: true,
      length: {minimum: 3, maximum: 128, default: ''}
    }
  },
  address: {
    type: 'number',
    default: 0,
    validators : {
      presence: true,
      numericality: {
        onlyInteger: true,
        greaterThanOrEqualTo: 0
      }
    }
  },
  length: {
    type: 'number',
    default : 1,
    validators: {
      presence: true,
      numericality: {
        onlyInteger: true,
        greaterThanOrEqualTo: 0
      },
    }
  },
  type: {
    type: 'string',
    default: 'uint16',
    validators: {
      presence: true      
    }
  },
  interval : {
    type: 'number',
    default: 600,
    numericality: {
      onlyInteger: true,
      greaterThanOrEqualTo: 0
    }
  },
  functionCode: {
    type: 'number',
    default: 3,
    validators: {
      presence: true,
      numericality: {
        onlyInteger: true,
        greaterThanOrEqualTo: 0,
        lessThanOrEqualTo: 64
      }
    }
  },
  status: {
    type: 'string'
  },
  error: {

  }
};

modbusAddress.initForm = function (record) {
  return loaders.requestWithLoader({
    url: '/api/v1/modbustypes',
    method: 'GET'
  })
  .then(r => {
    modbusAddress.types = prop(r)
    Model.initForm.call(modbusAddress, record);
    m.redraw();
  })
}

modbusAddress.view = function () {
  if(!modbusAddress.form) return 
  return  m('form', {role:'form'}, [
    modbusAddress.errorView(),
    m('div', {class:'form-group'}, [
      m('label', {for:'name-input'}, 'Name'),
      m('input.form-control', {
        id:'name-input', 
        type:'text', 
        oninput: function(ev){modbusAddress.form.name(ev.target.value)},
        value: modbusAddress.form.name(),
      })
    ]),
    m('div', {class:'form-group'}, [
      m('label', {for:'functionCode-input'}, 'functionCode'),
      m('input.form-control', {
        id:'functionCode-input', 
        autocomplete: 'off',
        type:'number', 
        oninput: function(ev){modbusAddress.form.functionCode(ev.target.value)},
        value: modbusAddress.form.functionCode(),
      })
    ]),
    m('div', {class:'form-group'}, [
      m('label', {for:'address-input'}, 'Address'),
      m('input.form-control', {
        id:'address-input', 
        autocomplete: 'off',
        type:'number', 
        oninput: function(ev){modbusAddress.form.address(ev.target.value)},
        value: modbusAddress.form.address(),
      })
    ]),
    m('div', {class:'form-group'}, [
      m('label', {for:'length-input'}, 'Length'),
      m('input.form-control', {
        id:'length-input', 
        autocomplete: 'off',
        type:'number', 
        oninput: function(ev){modbusAddress.form.length(ev.target.value)},
        value: modbusAddress.form.length(),
      })
    ]),
    m('div', {class:'form-group'}, [
      m('label', {for:'type-input'}, 'Type'),
      m("select.form-control", {
        id:"type-input" + modbusAddress.record['@rid'], 
        onchange: function(ev){modbusAddress.form.type(ev.target.value)},
        value: modbusAddress.form.type(),
      }, modbusAddress.types().map(function (t) {
          return m('option', {value: t}, t);
        })
      ),
    ]),
    m('div', {class:'form-group'}, [
      m('label', {for:'type-input'}, 'Polling Interval (Seconds)'),
       m('input.form-control', {
        id:'length-input', 
        autocomplete: 'off',
        type:'number', 
        oninput: function(ev){modbusAddress.form.interval(ev.target.value)},
        value: modbusAddress.form.interval(),
      })
    ])
  ])  
}

module.exports = modbusAddress;
